/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: fix types

import { useRef, useEffect, useState } from 'react';
import { sendViewSearchResultsAnalyticsEvent } from '@mb/lib/analytics';
import { getUserLang } from '@mb/lib/i18n';
import { SplitFeatureFlag, ContentBlocksTreatment } from '@mb/lib/splitio';
import { handleSystemErrorReport } from '@mb/lib/utils';
import { getAbtFeatureFlag } from '@mb/lib/utils/getAbtFeatureFlag';
import { StatusEnum as SnackbarStatusEnum } from 'components/components/MBSnackbar';
import flatten from 'lodash/flatten';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import pickBy from 'lodash/pickBy';
import startsWith from 'lodash/startsWith';
import uniq from 'lodash/uniq';
import xor from 'lodash/xor';
import { useSelector, useDispatch } from 'react-redux';
import {
  familyToggle,
  individualToggle,
} from '../components/Filter/FamilyViewSwitch';
import { config } from '../config';
import { searchActionsEnum } from '../config/constants';
import { gaAnalyticsContentBlocksExperiment } from '../containers/SearchResultsContainer/utilities';
import { useFiltersContext } from '../contexts';
import { reduxAdditionalFiltersSelector } from '../redux/selectors/filtersSelector';
import { appFiltersSelector } from '../redux/selectors/filtersSelector';
import {
  collectionHeaderSelector,
  xSessionIdSelector,
} from '../redux/selectors/searchSelector';
import { isSearchQueryRelaxedSelector } from '../redux/selectors/searchSelector';
import { currentSortOptionSelector } from '../redux/selectors/searchSortingSelector';
import { setSnackbarInfo } from '../redux/sliceCreators/commonSlice';
import {
  setOverrideParams,
  addFilter,
  setAppFilters,
  setIsColorCircleTopbarShown,
  setSearchToggle,
  setTaxonomyFilterValue,
  setAdditionalFilters,
} from '../redux/sliceCreators/filtersSlice';
import { setCampaignBanners } from '../redux/sliceCreators/searchSlice';
import {
  setCollectionHeader,
  setIsSearchQueryRelaxed,
  setIsSearchRedirect,
  setXRequestId,
  setXSessionId,
} from '../redux/sliceCreators/searchSlice';
import { ProductSearchResponse } from '../types/apiResponse';
import {
  getCookies,
  transformSearchspringResponseToAppFormat,
  getUrlParameter,
  addCookiesFilters,
} from '../utils';
import { levelDividerByFacet } from '../utils';
import {
  isHomePage,
  setQueryToUrl,
  getCharsNumber,
  isBannersPage,
  pushFilterAnalytics,
  mapV2ChildrenFilters,
} from '../utils/helpers';
import { isSearchPage } from '../utils/helpers';
import { getUserAttributes } from '../utils/localstorage';

type CurrentProdjectCookieType = {
  project_id: number;
  type: string;
  title: string;
  type_name: string;
  location_state: string;
};
type BodyPayloadType = {
  siteId: string;
  customerEmail: string;
  projectId: number;
  resultsPerPage: number;
  q: string;
  page: number;
  referrerUrl: string;
  customerId?: number | null;
  lang?: string;
  incognito?: boolean;
  esQuery?: boolean;
  routeId?: string;
  extraFields?: string[];
  contentBlocks?: boolean;
  contentBlocksMock?: boolean;
  contentBlocksQty?: number;
  relaxedQuery?: boolean;
  'segmentation.member.customer_group_name'?: string[];
  'segmentation.member.member_type_name'?: string[];
  'segmentation.member.primary_area_spec'?: string[];
  'segmentation.member.job_type'?: string[];
  'segmentation.member.is_test_user'?: string[];
  'segmentation.member.country_id'?: string[];
  'segmentation.member.state'?: string[];
  'segmentation.project.project_type'?: string[];
  'segmentation.project.phase_name'?: string[];
  'segmentation.project.state'?: string[];
  filterValueLimiter?: boolean;
  'bgfilter.visibility'?: string;
  'bgfilter.member_type'?: string;
  'bgfilter.country_permission'?: string;
  'bgfilter.state_permission'?: string;
  filterKey?: string;
  suggesterValue?: string;
  suggesterType?: string;
  sessionId?: string;
  [key: string]: unknown;
};
type RawCookieObjectType = {
  [key: string]: string;
};

const isBannersSearch = isBannersPage();

export function tryExtractUserCountry() {
  const publicUserData = localStorage.getItem('mage-cache-storage');
  const isUserLoggedIn = publicUserData != null;
  if (isUserLoggedIn) {
    const { customer } = JSON.parse(publicUserData);
    return customer?.country;
  }
}

export function tryExtractUserState() {
  const publicUserData = localStorage.getItem('mage-cache-storage');
  const isUserLoggedIn = publicUserData != null;
  if (isUserLoggedIn) {
    const { customer } = JSON.parse(publicUserData);
    return customer?.state;
  }
}

const dividers = [/>/g];
export const extraFieldsList = [
  'ss_facet_color_filter',
  'components',
  'family_id',
  'taxonomy',
  'is_orderable',
  'is_products',
  'is_paints',
  'is_finish',
  'is_geo_restricted',
  'group_id',
  'is_digital',
  'has_attachments',
];

export const SWITCHES_FIELDS = [
  'is_in_stock',
  'is_materials',
  'is_paints',
  'is_products',
];

const useSearchService = (overwriteSearchQuery: any) => {
  const dispatch = useDispatch();
  const { parseFilter, getNewFilters } = useFiltersContext();
  const currentSortOption = useSelector(currentSortOptionSelector);
  const appliedFilters = useSelector(appFiltersSelector);
  const isSearchQueryRelaxed = useSelector(isSearchQueryRelaxedSelector);
  const reduxAdditionalFilters = useSelector(reduxAdditionalFiltersSelector);
  const collectionHeader = useSelector(collectionHeaderSelector);
  const xSessionid = useSelector(xSessionIdSelector);
  const [prevSearchPayload, setPrevSearchPayload] = useState<
    BodyPayloadType | undefined
  >(undefined);
  const [prevFilters, setPrevFilters] = useState<
    { key: string; value: string }[]
  >([]);
  const userData = getUserAttributes();

  const customerCountry = useRef();
  const customerState = useRef();

  useEffect(() => {
    customerCountry.current = tryExtractUserCountry();
    customerState.current = tryExtractUserState();
  }, []);

  const search = async (
    searchOptions: any,
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    config = {} as any,
    {
      searchToggle = undefined,
      isBrandToggle = undefined,
    }: { searchToggle: string | undefined; isBrandToggle: boolean | undefined },
    isNewQuerySearch: boolean,
    suggestionsParams: any,
    predefinedIds: string[] = [],
    additionalFilters = {},
  ) => {
    let payloadAdditionalFilters = reduxAdditionalFilters;
    const { query, residentialCommercial } = searchOptions;
    const { resultsPerPage, currentPage, action, customerEmail } = config;
    const isNewSearch =
      action === searchActionsEnum.searchBar || isNewQuerySearch;
    const filters = {
      //wipe all filters directly on search, to avoid race conditions when going through context updates
      appFilters: isNewSearch
        ? []
        : flatten(Object.values(appliedFilters).map(parseFilter)),
    };

    if (action === searchActionsEnum.searchBar) {
      dispatch(setAdditionalFilters(additionalFilters));
      payloadAdditionalFilters = additionalFilters;
    }

    const urlQuery = getUrlParameter('q');
    if (query !== urlQuery && !isHomePage()) {
      setQueryToUrl(query);

      const queryToFetchBanners =
        (suggestionsParams?.suggesterValue?.length ?? 0) > 0
          ? suggestionsParams?.suggesterValue
          : query;
      const customEvent = new CustomEvent('trigger-banners-fetch', {
        detail: queryToFetchBanners,
      });
      window.dispatchEvent(customEvent);
    }

    const searchParams = {
      query,
      resultsPerPage,
      filters,
      searchToggle,
      isBrandToggle,
      action,
      page: currentPage ?? 1,
      customerEmail,
      residentialCommercial,
      suggestionsParams,
      predefinedIds,
      xSessionid,
      additionalFilters: payloadAdditionalFilters,
      appliedFilters,
    };
    return apiSearch(searchParams);
  };

  const apiSearch = async (searchParams: any) => {
    const searchURL =
      window?.mbSearch?.siteUrl ?? config?.searchSpring.searchURL;
    const siteId = window?.mbSearch?.siteId ?? config?.searchSpring?.siteId;
    try {
      const {
        query,
        page,
        resultsPerPage,
        filters,
        action,
        searchToggle,
        isBrandToggle,
        customerEmail,
        residentialCommercial,
        suggestionsParams,
        xSessionid,
        additionalFilters,
        appliedFilters,
      } = searchParams;

      const { appFilters } = filters;
      const searchForFamilies = searchToggle !== individualToggle;
      const isNewSearch = action === searchActionsEnum.searchBar;
      const isReset = action === searchActionsEnum.reset;
      const filterVisibility =
        searchForFamilies || isNewSearch ? 'Catalog| Search' : 'Catalog';
      // remove the parent filter if has a child selected

      if (!searchForFamilies && isNewSearch) {
        // Reset Colorways filter on New Search
        dispatch(setSearchToggle(familyToggle));
      }

      for (const filter of appFilters) {
        const divider = dividers.find((divider) =>
          new RegExp(divider).test(filter),
        );

        if (!divider) {
          continue;
        }

        const [parent] = filter.split(divider);
        const parentIndex = appFilters.indexOf(parent);

        if (parentIndex > -1) {
          appFilters.splice(parentIndex, 1);
        }
      }
      let mergedFilters = filters
        ? [...appFilters, `bgfilter.visibility=${filterVisibility}`]
        : [];
      if (!mergedFilters.some((filter) => filter?.includes('brand_product'))) {
        mergedFilters.push('bgfilter.brand_product=false');
      }

      if (currentSortOption != null && !isNewSearch) {
        const { field, direction } = currentSortOption;
        mergedFilters.push(`sort.${field}=${direction}`);
      }

      if (residentialCommercial?.length > 0) {
        mergedFilters.push(
          `bgfilter.residential_commerical=${residentialCommercial} Use`,
        );
      }

      let body: BodyPayloadType = {
        siteId,
        customerEmail,
        projectId: Number(userData?.current_project) || 0,
        resultsPerPage:
          Math.round(resultsPerPage) || config.search.resultsPerPage,
        q: query,
        page: Number(page) ?? 1,
        referrerUrl: window.location.host + window.location.pathname,
      };

      if (userData?.customer_id != null) {
        body['customerId'] = Number(userData?.customer_id) || null;
      }

      const askForContentBlocks = await getAbtFeatureFlag(
        SplitFeatureFlag.CONTENT_BLOCKS,
        ContentBlocksTreatment.OFF,
        action === searchActionsEnum.init ? 3 : 0,
      );

      if (isSearchPage() && Number(page) === 1 && askForContentBlocks) {
        const cookies: RawCookieObjectType = getCookies();

        const rawCookieProjectData = cookies?.selected_project_id ?? '';

        const cookieProjectData: CurrentProdjectCookieType = JSON.parse(
          decodeURIComponent(rawCookieProjectData) || '{}',
        );

        // content blocks values
        body['contentBlocks'] = true;
        body['contentBlocksQty'] = 8;
        body['segmentation.member.customer_group_name'] = [
          `${userData?.groupName || ''}`,
        ];
        body['segmentation.member.member_type_name'] = [
          `${userData?.member_type || ''}`,
        ];
        body['segmentation.member.primary_area_spec'] = [
          `${userData?.area_spec || ''}`,
        ];
        body['segmentation.member.job_type'] = [`${userData?.job_type}`];
        body['segmentation.member.is_test_user'] = [`${userData?.isTestUser}`];
        body['segmentation.member.country_id'] = [`${userData?.country}`];
        body['segmentation.member.state'] = [`${userData?.state}`];

        body['segmentation.project.project_type'] = [
          `${cookieProjectData?.type_name || ''}`,
        ];
        body['segmentation.project.phase_name'] = [
          `${userData?.current_project_phase_name || ''}`,
        ];
        body['segmentation.project.state'] = [
          `${cookieProjectData?.location_state || ''}`,
        ];
      }

      // check if user comes from Mega Menu
      const isFromMegamenu = window.location.href?.includes('megaMenuLink');

      // Limit values, when coming from Brands page
      if (window.location.href?.includes('filterValueLimiter')) {
        body['filterValueLimiter'] = true;
      }

      if (isSearchQueryRelaxed && !isNewSearch) {
        body['relaxedQuery'] = true;
      }

      if (window?.mbSearch?.filters != null) {
        for (const filter of window?.mbSearch?.filters) {
          for (const [key, value] of Object.entries(filter)) {
            body[key] = value;
          }
        }
      }
      if (window.location.href.includes('/all/')) {
        body['bgfilter.visibility'] = 'Catalog';
      }
      if (userData?.member_type != null) {
        body['bgfilter.member_type'] = String(userData?.member_type);
      }
      if (customerCountry) {
        body['bgfilter.country_permission'] = customerCountry.current;
      }

      const configLang =
        typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : null;

      if (customerState && configLang !== 'EU') {
        body['bgfilter.state_permission'] = customerState.current;
      }

      if (configLang != null) {
        body['lang'] = `${getUserLang()}-${ENVIRONMENT_REGION}`;
      }

      body['extraFields'] = extraFieldsList;

      const suggesterValue =
        getUrlParameter('suggesterValue') || suggestionsParams?.suggesterValue;

      if (suggesterValue) {
        body['suggesterValue'] = suggesterValue;
      }

      const suggesterType =
        getUrlParameter('suggesterType') || suggestionsParams?.suggesterType;
      if (suggesterType) {
        body['suggesterType'] = suggesterType;
      }

      const searchType =
        getUrlParameter('searchType') || suggestionsParams?.searchType;

      // Do not include parent group in payload, if child selected
      const currentMergedFilters = [...mergedFilters];
      mergedFilters = mergedFilters.filter((item) => {
        const itemChunks = item.split(/[.=]/);
        const multiFilter = levelDividerByFacet?.[itemChunks?.[1]];
        if (multiFilter == null) {
          return true;
        }
        const isChildApplied = currentMergedFilters?.some(
          (item) =>
            item.includes(multiFilter.field) &&
            getCharsNumber(item, multiFilter.sign) === multiFilter.signCount,
        );
        if (isChildApplied) {
          return !(
            item.includes(multiFilter.field) &&
            getCharsNumber(item, multiFilter.sign) === multiFilter.signCount - 1
          );
        }
        return true;
      });

      if (Array.isArray(mergedFilters)) {
        mergedFilters.forEach((filter) => {
          if (filter && filter.includes('relevance')) {
            return;
          }
          try {
            const [filterKey, filterValue] = filter.split('=');
            const filterType = filterKey.split('.')[1];
            let finalFilterValue = ['true', 'false'].includes(filterValue)
              ? filterValue === 'true'
              : filterValue;

            if (SWITCHES_FIELDS.includes(filterType)) {
              finalFilterValue = true;
            }

            if (filterKey.indexOf('filter.price_sign_filter') !== -1) {
              finalFilterValue = Number(filterValue);
            }

            if (body[filterKey] != null) {
              if (Array.isArray(body[filterKey])) {
                body[filterKey].push(finalFilterValue);
              } else {
                body[filterKey] = [body[filterKey], finalFilterValue];
              }
            } else {
              body[filterKey] = finalFilterValue;
            }
          } catch (e) {
            handleSystemErrorReport(
              `Error parsing filters: ${e.message}`,
              'fetchSearchspringResponse',
            );
          }
        });
      }

      body = { ...body, ...additionalFilters };

      addCookiesFilters(body, isBrandToggle);

      const {
        sessionId: bodySessionId,
        relaxedQuery = null,
        ...bodyRest
      } = body;
      const {
        sessionId: prevSessionId,
        relaxedQuery: prevRelaxedQuery = null,
        ...prevSearchPayloadRest
      } = prevSearchPayload ?? {}; // Add a fallback to an empty object if prevSearchPayload is undefined

      if (
        isEqual(bodyRest, prevSearchPayloadRest) &&
        !isNewSearch &&
        !isBannersSearch
      ) {
        return;
      }
      if (xSessionid != null && !isNewSearch && !isFromMegamenu && !isReset) {
        body['sessionId'] = xSessionid;
      }
      if (!isBannersSearch) {
        setPrevSearchPayload(body);
      }
      if (isReset) {
        window.dispatchEvent(
          new CustomEvent('searchFilterRemove', {
            detail: { isReset: true },
          }),
        );
      }

      dispatch(setTaxonomyFilterValue(undefined));

      const bodyFilters = pickBy(body, (value, key) => {
        return startsWith(key, 'filter.');
      });

      const childrenFilters = mapV2ChildrenFilters(bodyFilters);

      const childrenBody = {
        customer: {
          id: String(userData?.customer_id) || null,
          email: userData?.email,
          country: userData?.country,
          province: userData?.state,
        },
        siteId,
        lang: `${getUserLang()}-${ENVIRONMENT_REGION || 'US'}`,
        incognito: true,
        esQuery: false,
        resultsPerPage:
          Math.round(resultsPerPage) || config.search.resultsPerPage,
        page: Number(page) ?? 1,
        routeId: window.location.pathname?.split('/')?.pop(),
        filters: childrenFilters || [],
        extraFields: extraFieldsList,
      };

      const finalUrl = isBannersSearch
        ? config.searchSpring.children
        : searchURL;
      const finalBody: Partial<BodyPayloadType> = isBannersSearch
        ? childrenBody
        : body;
      let data: ProductSearchResponse = {};
      try {
        data = await fetch(finalUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(finalBody),
        }).then((res) => {
          if (!res.ok) {
            throw new Error('Error fetch search results');
          }
          const xRequestId = res.headers.get('x-request-id');
          if (xRequestId != null) {
            dispatch(setXRequestId(xRequestId));
            if (isNewSearch || xSessionid == null) {
              dispatch(setXSessionId(xRequestId));
            }
          }
          return res.json();
        });
      } catch (e) {
        console.log(e);
        if (isBannersSearch) {
          dispatch(
            setSnackbarInfo({
              isOpen: true,
              message: 'Collection not found',
              status: SnackbarStatusEnum.DANGER,
            }),
          );
          handleSystemErrorReport(
            `Collection not found: ${e.message}`,
            'fetchSearchspringResponse',
          );
          const userLang = getUserLang();
          const env = ENVIRONMENT_REGION || 'US';
          if (env === 'EU') {
            window.location.href = `/${userLang}/curatedcollections`;
          } else {
            window.location.href = '/curatedcollections';
          }
        }
      }

      // Analytics from Searchbar
      if (searchType != null) {
        sendViewSearchResultsAnalyticsEvent({
          query: body['suggesterValue'] || body['q'],
          searchType,
          resultsNumber: data?.pagination?.totalResults || 0,
        });
      }

      if (data?.redirectUrl != null) {
        window.location.replace(data?.redirectUrl);
        //this will block the execution of JS to not show an empty page before redirection takes place

        // @ts-ignore
        await new Promise(() => {});
      }

      dispatch(setCampaignBanners(data?.campaign?.banners ?? []));
      gaAnalyticsContentBlocksExperiment(data?.contentBlocks?.results?.length);

      if (data?.results == null) {
        return { ...data, results: [] };
      }

      if (data?.header?.[0] != null && collectionHeader == null) {
        dispatch(setCollectionHeader(data?.header?.[0]));
      }

      const results = data.results.map(
        transformSearchspringResponseToAppFormat,
      );

      const addNewFilters = (
        keyValueArr: { key: string; value: unknown }[] = [],
      ) => {
        const newFilters = flatten(
          keyValueArr?.map((item: { key: string; value: string }) =>
            getNewFilters(item.key, item.value, appFilters),
          ),
        );
        if (newFilters?.length > 0) {
          dispatch(addFilter(newFilters));
        }
      };

      const allowedOverrides = ['filter', 'q', 'q_original', 'sort'];
      let currentSelectedColor = finalBody?.['filter.virtual_color_group'];

      const paramsOverrides = data?.overrides ?? data?.paramsOverrides;
      const newFilters: { key: string; value: unknown }[] = [];
      let newSearchToggle = null;

      if (!isEmpty(additionalFilters)) {
        Object.entries(additionalFilters).forEach(([key, value]) => {
          newFilters.push({ key, value });
        });
      }
      if (paramsOverrides) {
        //iterate over the params override
        const filteredParams = Object.fromEntries(
          Object.entries(paramsOverrides)?.filter(([key]) => {
            const mainKey = key.split('.')?.[0];
            return (
              allowedOverrides.includes(mainKey) && !key.includes('color_data')
            );
          }),
        );
        dispatch(
          setOverrideParams(isEmpty(filteredParams) ? null : filteredParams),
        );
        Object.entries(paramsOverrides).forEach(([key, value]) => {
          //and handle only the filters
          if (
            key.includes('filter') &&
            !key.includes('bgfilter') &&
            !key.includes('filter.color_data')
          ) {
            if (value != null) {
              if (key.includes('taxonomy')) {
                const currentValue = Array.isArray(value) ? value?.[0] : value;
                // If subcategory comes as filter, make sure to add parent as well for better toggle functionality
                const taxonomyLevel = getCharsNumber(currentValue, '>');
                const taxonomyValue = Array.isArray(value) ? value : [value];
                const isMultipleParents =
                  uniq(taxonomyValue?.map((item) => item.split('>')?.[1]) || [])
                    ?.length > 1;
                if (taxonomyLevel === 2 && !isMultipleParents) {
                  const levels = currentValue?.split('>');
                  levels.pop();
                  const parent = levels.join('>');
                  newFilters.push({ key, value: parent }, { key, value });
                } else {
                  newFilters.push({ key, value });
                }
              } else {
                newFilters.push({ key, value });
              }
            } else {
              const filtersToRemove = Object.keys(appliedFilters).filter(
                (item) => item.includes(key),
              );
              if (filtersToRemove?.length > 0) {
                const clearedFilters = omit(appliedFilters, filtersToRemove);
                dispatch(setAppFilters(clearedFilters));
              }
            }
          }
          if (key === 'filter.virtual_color_group') {
            currentSelectedColor = value;
            dispatch(setIsColorCircleTopbarShown(true));
          }
          if (key === 'q') {
            setNewQuery(overwriteSearchQuery, query, String(value));
          }
          if (key === 'bgfilter.visibility') {
            newSearchToggle =
              value === 'Catalog' ? familyToggle : individualToggle;
          }
          if (key === 'is_relaxedquery') {
            dispatch(setIsSearchQueryRelaxed(value));
          }
          if (key === 'is_redirect') {
            dispatch(setIsSearchRedirect(value));
          }
        });
      }
      if (newFilters?.length > 0) {
        addNewFilters(newFilters);
      }
      if (newSearchToggle != null) {
        dispatch(setSearchToggle(newSearchToggle));
      }

      // Applied Filter Analytics
      const overrideFilters = newFilters?.map(
        ({ key, value }: { key: string; value: string }) => `${key}=${value}`,
      );
      const currentFilters = [...appFilters, ...overrideFilters].filter(
        (item) => !item.includes('price_sign_filter.low'),
      );
      const prevFilterLength = prevFilters?.length;
      const filterLength = currentFilters?.length;

      if (
        (filterLength !== prevFilterLength ||
          !isEqual(prevFilters, currentFilters)) &&
        !isFromMegamenu
      ) {
        const diffFilters = xor(prevFilters, currentFilters);
        const isAdded = filterLength >= prevFilterLength;
        const isClearedAll =
          action === searchActionsEnum.reset &&
          prevFilterLength - filterLength > 1;
        pushFilterAnalytics({
          resultsNumber: data.pagination?.totalResults || 0,
          isReset: isClearedAll,
          filter: diffFilters?.pop(),
          isAdded,
        });
      }

      setPrevFilters(currentFilters);

      const contentBlocks = data?.contentBlocks?.results ?? [];

      return {
        ...data,
        results,
        contentBlocks,
        isFromMegamenu,
        currentSelectedColor,
      };
    } catch (error) {
      handleSystemErrorReport(
        `Error fetchSearchspringResponse: ${error.message}`,
        'fetchSearchspringResponse',
      );
      console.error({ error });
      return {
        results: [],
        contentBlocks: [],
        isFromMegamenu: false,
        currentSelectedColor: null,
      };
    }
  };

  return { search, apiSearch };
};

function setNewQuery(
  overwriteFn: (value: string) => void,
  prevQuery: string,
  newValue: string,
) {
  const setSearchInputEvent = new CustomEvent('searchQueryResultsChange', {
    detail: {
      query: newValue,
    },
  });
  document.dispatchEvent(setSearchInputEvent);
  if (prevQuery !== newValue) {
    overwriteFn(newValue);
    const newHistoryPath = window.history.state?.path?.replace(
      `q=${prevQuery?.replaceAll(' ', '+')}`,
      `q=${newValue}`,
    );
    window.history.pushState(
      {
        path: newHistoryPath,
      },
      document.title,
      newHistoryPath,
    );
  }
}

export { useSearchService };
